import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory from '../modelFactory';
import model from './model';

export interface IJobCostPaymentTerm {
	changeOrderKey?: string;
	description?: string;
	amountDue?: number;
	sortIndex?: number;
}

const jobPaymentTermFactory = modelFactory.createFactory<IJobCostPaymentTerm>('JobPaymentTerm', _.assign({}, model, {
	changeOrderKey: {
		setFilters: valueFilters.clean
	},
	description: {
		rules: validator.required()
	},
	amountDue: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: [
			(value, target) => {
				if (!target.changeOrderKey) {
					return (value > 0) || 'Amount Due must be greater than zero.';
				}
			}
		]
	},
	sortIndex: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: validator.number(true) // allow undefined
	}
}));

export default jobPaymentTermFactory;